import signUpLeadComponent from './sign-up-lead.component';

const signUpLeadModule = angular.module('signUpLead', [
])
  .component('signUpLead', signUpLeadComponent)
  .name;

export default signUpLeadModule;
